/* @ngInject */
const pieceFormat = (
  utils,
  valueHandler
) => {
  const self = {}

  self.server = (_piece) => {
    if (valueHandler.isArray(_piece)) {
      const pieces = utils.copy(_piece)
      for (let index = 0; index < pieces.length; index++) {
        pieces[index] = self.server(pieces[index])
      }
      return pieces
    }
    const piece = utils.copy(_piece)

    piece.sendingDate = utils.date.stringToServer(piece.sendingDate)

    return piece
  }

  self.user = (_piece) => {
    if (valueHandler.isArray(_piece)) {
      const pieces = utils.copy(_piece)
      for (let index = 0; index < pieces.length; index++) {
        pieces[index] = self.user(pieces[index])
      }
      return pieces
    }
    const piece = utils.copy(_piece)

    piece.sendingDate = utils.date.timestampToString(piece.sendingDate)

    return piece
  }

  return self
}
export default pieceFormat



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/services/format.service.js